import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import FallingFlowers from "../../FallingFlowers/FallingFlowers";

const DefaultStyle = ({ children }) => {
    return (
        <>
            <Header />
            <FallingFlowers />
            <main>{children}</main>
            <Footer />
        </>
    );
};

export default DefaultStyle;
